module.exports = __webpack_public_path__ + "img/lc-front-chl.1b3fb782.svg";